import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';

class Tooltip extends React.Component {
  static get propTypes() {
    return {
      title: PropTypes.string.isRequired,
      powerTipOptions: PropTypes.object,
      className: PropTypes.string,
      children: PropTypes.node,
      underline: PropTypes.bool,
    };
  }

  componentDidMount() {
    $(this.refs.tooltip).powerTip(this.powerTipOptions);
  }

  get powerTipOptions() {
    return { smartPlacement: true,
      mouseOnToPopup: true,
      ...(this.props.powerTipOptions || {}) };
  }

  contents() {
    if (this.props.children) {
      return this.props.children;
    }

    return <i className="fa fa-question-circle" />;
  }

  render() {
    const classes = classNames('tooltip', this.props.className, {
      'tooltip--underline': this.props.underline,
    });

    return (
      <span
        className={classes}
        ref="tooltip"
        title={this.props.title}
      >
        {this.contents()}
      </span>
    );
  }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./javascripts/components/tooltip.jsx